<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
        @keydown.enter="triggerSubmit"
        :key="open"
      >
        <FormOrder
          ref="formOrder"
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          @itemUpdate="updateDataSelect"
          :preSettlement="description"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        @keydown.enter="confirmDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import FormOrder from "@/components/Complement/FormOrder.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import costCenters from "@/store/centrosDeCosto/costCenters";
import concepts from "@/store/conceptos/concepts";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import actions from "../commons/PreSettlementRulesActions.json";

export default {
  components: {
    Table,
    FormOrder,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: "Reglas de pre liquidación",
      titleTable: "ModelosDeLiquidacion_ReglasDePreLiquidacion",
      titleDelete: this.$tc("modelsLiquidations.toRuleLiquidationLiquidation"),
      isLoading: true,
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      textRule: "",
      headers: [
        {
          text: "Acción",
          value: "accion",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Concepto 1",
          value: "conceptoId_1",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "CsCosto 1",
          value: "csCostoId_1",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto 2",
          value: "conceptoId_2",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "CsCosto 2",
          value: "csCostoId_2",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataInputsHours: [],
      formKey: 0,
      description: "",
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.instancias ||
        modelsLiquidation.state.edit.instancias.length === 0
      ) {
        return [];
      }

      return modelsLiquidation.state.edit.reglasPreLiq;
    },
    concepts() {
      const allConcepts = concepts.state.concepts;

      const filteredConcepts = allConcepts.filter((concept) => concept.id > 4);

      return filteredConcepts;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "regla",
            type: "select",
            label: "Selecciona una regla",
            items: actions.map((item) => item.name),
            itemText: "initials",
            itemValue: "initials",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: false,
            data: "",
            name: "tolerancia",
            type: "text",
            label: "Ingresa cantidad de horas (hh:mm)",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("editRegistrations.requerid"),
              (v) => {
                const regex = /^-?(\d{1,3}):([0-5][0-9])$/;
                if (!regex.test(v)) {
                  return this.$tc("modelsLiquidations.formatError", {
                    format: "00:00",
                  });
                }
                return true;
              },
            ],
            order: 2,
          },
          {
            id: 3,
            show: false,
            data: "",
            name: "conceptoId_1",
            type: "select",
            label: "Concepto 1",
            items: [],
            itemText: "name",
            itemValue: "conceptId",
            rules: [],
            order: 3,
          },
          {
            id: 4,
            show: false,
            data: "",
            name: "csCostoId_1",
            type: "select",
            label: "Centro de Costo 1",
            items: [],
            itemText: "name",
            itemValue: "id",
            rules: [],
            order: 4,
          },
          {
            id: 5,
            show: false,
            data: "",
            name: "conceptoId_2",
            type: "select",
            label: "Concepto 2",
            items: [],
            itemText: "name",
            itemValue: "conceptId",
            rules: [],
            order: 5,
          },
          {
            id: 6,
            show: false,
            data: "",
            name: "csCostoId_2",
            type: "select",
            label: "Centro de Costo 2",
            items: [],
            itemText: "name",
            itemValue: "id",
            rules: [],
            order: 6,
          },
        ],
      };
    },
    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await concepts.dispatch("getConcepts");
    await costCenters.dispatch("getCostCenters");
    this.isLoading = false;
  },
  created() {
    this.$root.$on("select-updated", this.handleSelectUpdated);
  },
  methods: {
    triggerSubmit() {
      if (this.$refs.formOrder) {
        this.$refs.formOrder.submitForm();
      }
    },
    descriptionAlert() {
      const item = actions.find(
        (element) => element.name === this.parameters.items[0].data
      );
      return item ? item.description : "";
    },
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    async updateDataSelect(selectedSelect) {
      this.description = await this.descriptionAlert();
      const updatedField = this.parameters.items.find(
        (field) => field.name === selectedSelect.name
      );

      if (updatedField) {
        updatedField.data = selectedSelect.data;
      }

      if (updatedField && updatedField.name === "regla") {
        const action = actions.find(
          (element) => element.name === selectedSelect.data
        );

        if (action) {
          this.textRule = action.description;
          this.updateSelectsBasedOnRule(selectedSelect.data);
        }
      }
    },

    updateSelectsBasedOnRule(selectedRule) {
      const filterConceptRule = {
        AUSENTE: { LicTot: "N" },
        TARDE: { LicTot: "N", HorTrab: "N" },
        RETANT: { LicTot: "N", HorTrab: "N" },
        INENT: { LicTot: "N", HorTrab: "N" },
        INSAL: { LicTot: "N", HorTrab: "N" },
        JUNTAR: {},
        ENTSALI: { LicTot: "N", HorTrab: "N" },
      };

      const ruleConditions = filterConceptRule[selectedRule];
      const filteredConcepts = this.concepts.filter((concept) => {
        if (ruleConditions) {
          return (
            concept.fullDayLicense === ruleConditions.LicTot ||
            concept.workHours === ruleConditions.HorTrab
          );
        }
        return false;
      });

      const selectsToAdd = {
        AUSENTE: ["tolerancia", "conceptoId_1", "csCostoId_1"],
        TARDE: [
          "tolerancia",
          "conceptoId_1",
          "csCostoId_1",
          "conceptoId_2",
          "csCostoId_2",
        ],
        RETANT: [
          "tolerancia",
          "conceptoId_1",
          "csCostoId_1",
          "conceptoId_2",
          "csCostoId_2",
        ],
        INENT: ["tolerancia", "conceptoId_1", "csCostoId_1"],
        INSAL: ["tolerancia", "conceptoId_1", "csCostoId_1"],
        JUNTAR: ["tolerancia"],
        ENTSALI: [
          "tolerancia",
          "conceptoId_1",
          "csCostoId_1",
          "conceptoId_2",
          "csCostoId_2",
        ],
      };

      const selectsToShow = selectsToAdd[selectedRule] || [];

      // Establecer `show` en false para todos los campos excepto "regla"
      this.parameters.items.forEach((field) => {
        if (field.name !== "regla") {
          field.show = selectsToShow.includes(field.name);
        }
      });

      // Configurar dinámicamente los datos de los campos visibles
      this.parameters.items.forEach((field) => {
        if (field.show) {
          if (field.name.startsWith("conceptoId")) {
            field.items = filteredConcepts;
            field.itemValue = "conceptId";
          } else if (field.name.startsWith("csCostoId")) {
            field.items = this.costCenters;
          }
        }
      });
    },

    addRulePreLiquidation(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;

      if (payload.tolerancia) {
        payload.tolerancia = this.convertToMinutes(payload.tolerancia);
      }
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addRulePreLiquidation")
        .then(() => {
          this.showAlert(
            this.$tc(
              "modelsLiquidations.addRulePreLiquidationToLiquidationSuccess"
            ),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorRulePreLiquidation"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },

    editPreRuleLiquidation(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;

      if (payload.tolerancia) {
        payload.tolerancia = this.convertToMinutes(payload.tolerancia);
      }
      modelsLiquidation.commit("setEditRelation", payload);
      modelsLiquidation
        .dispatch("editRulePreLiquidation")
        .then(() => {
          this.showAlert(
            this.$tc(
              "modelsLiquidations.editRulePreLiquidationToLiquidationSuccess"
            ),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorRulePreLiquidation"),
            "#ff8d58"
          );
        });

      this.reset(false);
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.parameters.items[0].disabled = false;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addRuleLiquidationToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          await this.updateSelectsBasedOnRule(item.accion);
          this.itemId = item.id;
          this.oldItems = item;
          this.setEdit(item);
          this.parameters.items[0].disabled = true;
          this.description = await this.descriptionAlert();
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editRuleLiquidationToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      if (item.accion !== null) {
        this.parameters.items[0].data = item.accion;
      }
      if (item.cantHoras !== null) {
        let hour = this.convertToHours(item.cantHoras);
        this.parameters.items[1].data = hour;
      }
      if (item.conceptoId_1 !== null) {
        this.parameters.items[2].data = item.conceptoId_1;
      }
      if (item.csCostoId_1 !== null) {
        this.parameters.items[3].data = item.csCostoId_1;
      }
      if (item.conceptoId_2 !== null) {
        this.parameters.items[4].data = item.conceptoId_2;
      }
      if (item.csCostoId_2 !== null) {
        this.parameters.items[5].data = item.csCostoId_2;
      }
    },

    reset(value) {
      this.description = "";
      this.parameters.items[0].disabled = false;
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.parameters.items.forEach((item) => {
        item.data = "";
        if (item.id !== 1) {
          item.show = false;
        }
      });
      this.textRule = "";
      this.dataInputsHours.forEach((item) => {
        item.data = "";
      });
      this.dataInputsHours = [];
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addRulePreLiquidation(items);
          break;
        case "edit":
          this.editPreRuleLiquidation(items);
          break;
        default:
          break;
      }
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    convertToHours(minutos) {
      if (typeof minutos !== "number" || minutos < 0) {
        return "Invalido";
      }

      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;

      const horasFormateadas = horas.toString().padStart(2, "0");
      const minutosFormateados = minutosRestantes.toString().padStart(2, "0");

      return horasFormateadas + ":" + minutosFormateados;
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteRulePreLiquidation")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
